
import * as React from 'react';

import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { PIVOT_KEY } from '../common/consts';

import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import { IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { Icon, ImageIcon } from 'office-ui-fabric-react';

import log from 'loglevel';
import { useErrorBoundary } from "use-error-boundary";
import { classNames, controlStyles, iconStyle } from "./itemsDataList.Styles";
const overflowProps = { ariaLabel: 'More commands' };



 export const ItemsDataList =()=> {

  const { state, dispatch } = useContext(MessagesContext);
  const [filterString, setFilterString] = useState('');
  const [filteredItems, setFilteredItems] = useState(state.messages);
  const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
  
  log.info(` @ItemsDataList`);
  /**
   * Will update the local state of FiteredItems at any change of state.messages from context
   * (for example if we want to clear the messages that were pushed to items, we would clear the stata.messages and it would refresh the list )
   */
  useEffect(() => {
    log.info(`useEffect @ ItemsDataList`);
    setFilteredItems(state.messages);

  }, [state.messages])

  let _selection = new Selection({
    
    onSelectionChanged: () => {
      log.info(`onSelectionChanged @ ItemsDataList`);
      // This will update the resdux every time there is a change in the selection, but might be a potential for a performance issue  
      const _selectedItems = _selection.getSelection();
      dispatch({ type: "SET_SELECTED_ITEMS", payload: {selectedItems : _selectedItems} });
    }
  });

  const onColumnClick = (ev, column) => {
    //alert('column click');
  }
  

  const columns = [
    {
      key: 'column1',
      name: 'Item Type',
      className: classNames.fileIconCell,
      iconClassName: classNames.fileIconHeaderIcon,
      iconName: 'Message',
      isIconOnly: true,
      fieldName: 'name',
      minWidth: 16,
      maxWidth: 16,
      onRender: (item) => {

        const _iconName = item.type == "Message" ? 'MessageFill' : 'Message' 
        
        return (
          <Icon style={iconStyle()} iconName={_iconName} />
         )
       }
    },
    {
      key: 'column2',
      name: 'Item',
      fieldName: 'text',
      minWidth: 210,
      maxWidth: 350,
      isRowHeader: true,
      isResizable: true,
      isSorted: true,
      isSortedDescending: false,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      onColumnClick: onColumnClick,
      data: 'string',
      isPadded: true
    },
    {
      key: 'column3',
      name: 'Date Posted',
      fieldName: 'date',
      minWidth: 70,
      maxWidth: 90,
      isResizable: true,
      onColumnClick: onColumnClick,
      data: 'string',
      onRender: (item) => {
        return <span>{item.date}</span>;
      },
      isPadded: true
    },
    {
      key: 'column4',
      name: 'Posted By',
      fieldName: 'user',
      minWidth: 70,
      maxWidth: 90,
      isResizable: true,
      isCollapsible: true,
      data: 'string',
      onColumnClick: onColumnClick,
      onRender: (item) => {
        return <span>{item.user}</span>;
      },
      isPadded: true
    }
  ];

  const handleItemInvoked = (item) =>{
    log.info(`handleItemInvoked @ ItemsDataList`);
   // alert(`Item invoked: ${item.name}`);
  }

  const  getKey = (item, index) => {
      log.info(`getKey @ ItemsDataList`);
      return item.key;
  }

  const handleUpdateEdit = () => {      
      log.info(`handleUpdateEdit @ ItemsDataList`);
      // turns out there is a bug in th ecomponent that during the first call to handleUpdateEdit
      // it does not report on the selected items correctly
      // this is why the dispatch is applied at every update of th ecomponent and not when the user wants to move to edit
      //  let _selectedItems = _selection.getSelection();
      //  _selectedItems = _selection.getSelection();
      //  alert(`handleUpdateEdit FOR SELECTED ITEMS: ${JSON.stringify(_selectedItems)}`)
      //  const _payload = {selectedItems : _selectedItems};
      //  dispatch({ type: "SET_SELECTED_ITEMS", payload: _payload });
    
    const __payload = { loadSelectedItems: true };
    dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: __payload });

    const ___payload = { pivotKey:  PIVOT_KEY.EDIT};
    dispatch({ type: "SET_PIVOT_KEY", payload: ___payload })
  
  };
/**
 * 
 * Deletes Items and the editor items
 * 
 */
  const handleDelete = () => {      
 
      log.info(`handleDelete @ ItemsDataList`);
      const _payloadRemoveMessages = {selectedItems : []};
      dispatch({ type: "REMOVE_MESSAGES", payload: _payloadRemoveMessages });
    
      //Clear content to Editor
      const _payload = {selectedItems : []};
      dispatch({ type: "SET_SELECTED_ITEMS", payload: _payload });
      
      // set the flag to reload the content at the editor
      const __payload = { loadSelectedItems: true };
      dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: __payload });
   
  };
 
  const renderUpdateEdit =()=>{
    log.info(`renderUpdateEdit @ ItemsDataList`);
    return (
    <>
    <PrimaryButton 
      onClick={() => {handleUpdateEdit()}} 
      style={{ marginRight: "8px" }}> 
      Update Editor >>>
    </PrimaryButton>
    </>
    )
  }
  
  const _items = [
    {
      key: 'share',
      text: 'Submit',
      iconProps: { iconName: 'Share' },
      onClick: () => handleUpdateEdit()
    },
    {
      key: 'delete',
      text: 'Delete',
      iconProps: { iconName: 'Share' },
      onClick: () => handleDelete()
    }  
  ];
 
  
  const renderCommandBar=()=>{
      log.info(`renderCommandBar @ ItemsDataList`);
      return (
              <CommandBar
                      items={_items}
                    />
              );  
  };
  const MyErrorComponent = ({error})=>{
    log.error(`error ${error.message}`);
    return (
    <div >error</div>
    )
  }


const renderDetailsList = () =>{
  if (filteredItems == null || filteredItems == undefined  ){
    return (
      <>  
      <Spinner size={SpinnerSize.large} />
      </> 
    )
  } else {
    return (
          <ErrorBoundary  
          render={() => 
            <MarqueeSelection selection={_selection}>
              <DetailsList
                items={filteredItems}
                compact= {true}
                columns={columns}
                selectionMode={SelectionMode.multiple}
                getKey={getKey}
                setKey="multiple"
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                selection={_selection}
                selectionPreservedOnEmptyClick={true}
                onItemInvoked={handleItemInvoked}
                enterModalSelectionOnTouch={true}
              />
            </MarqueeSelection>       
            }
          renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}             
        >
        </ErrorBoundary>                              
    )
  }
}


  
   return(
     <>
        {renderCommandBar()}
        {renderDetailsList()}
      </> 
    )             
}
 

  // useEffect(() => {
    
  //   return () => {
  //     //This will update the resux store on dismount, commonly on change of tab
  //    // const _selectedItems = _selection.getSelection();
  //    //alert(`_selectedItems ${_selectedItems.length}`)
  //    // dispatch({ type: "SET_SELECTED_ITEMS", payload: {selectedItems : _selectedItems} });
  //   };
  // }, [])



  //  const onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
  //   const { columns, items } = this.state;
  //   const newColumns: IColumn[] = columns.slice();
  //   const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
  //   newColumns.forEach((newCol: IColumn) => {
  //     if (newCol === currColumn) {
  //       currColumn.isSortedDescending = !currColumn.isSortedDescending;
  //       currColumn.isSorted = true;
  //       this.setState({
  //         announcedMessage: `${currColumn.name} is sorted ${currColumn.isSortedDescending ? 'descending' : 'ascending'}`
  //       });
  //     } else {
  //       newCol.isSorted = false;
  //       newCol.isSortedDescending = true;
  //     }
  //   });
  //   const newItems = _copyAndSort(items, currColumn.fieldName!, currColumn.isSortedDescending);
  //   this.setState({
  //     columns: newColumns,
  //     items: newItems
  //   });
  // };

  // function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
  //   const key = columnKey as keyof T;
  //   return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
  // }


// {
//   id :  message.id,
//   date: message.createdDateTime ? message.createdDateTime : 'not available',
//   text : `[M:]${message.body.content.trim()}`,
//   webUrl : message.webUrl,
//   user : message.from.user.displayName,
//   type : "Message",
//   selected : true
// };

// function _generateDocuments() {
//   const items: IItem[] = [...state.messages];
   
//   return items;
// }

// function _randomDate(start: Date, end: Date): { value: number; dateFormatted: string } {
//   const date: Date = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
//   return {
//     value: date.valueOf(),
//     dateFormatted: date.toLocaleDateString()
//   };
// }

// const FILE_ICONS: { name: string }[] = [
//   { name: 'accdb' },
//   { name: 'csv' },
//   { name: 'docx' },
//   { name: 'dotx' },
//   { name: 'mpt' },
//   { name: 'odt' },
//   { name: 'one' },
//   { name: 'onepkg' },
//   { name: 'onetoc' },
//   { name: 'pptx' },
//   { name: 'pub' },
//   { name: 'vsdx' },
//   { name: 'xls' },
//   { name: 'xlsx' },
//   { name: 'xsn' }
// ];

// function _randomFileIcon(): { docType: string; url: string } {
//   const docType: string = FILE_ICONS[Math.floor(Math.random() * FILE_ICONS.length)].name;
//   return {
//     docType,
//     url: `https://static2.sharepointonline.com/files/fabric/assets/brand-icons/document/svg/${docType}_16x1.svg`
//   };
// }
